import React from 'react';
import {timestamp2seconds} from "../../../helper/helper";
import {useAtom} from "jotai";
import {captionItemState, captionListState} from "../../../states/caption";
import {CaptionListProps} from "../../../types/caption";
import styled from "styled-components";
import {initializeState} from "../../../states/initialize";

type CaptionDataProps = {
  captionData: CaptionListProps
}

/**
 주석 설명

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date
 */

export default function CaptionETC({captionData}: CaptionDataProps) {

  const [{text_limit, caption_max_time, caption_min_time}] = useAtom(initializeState)
  const duration = (timestamp2seconds(captionData.time_end) - timestamp2seconds(captionData.time_ini))
  
  const isInvalidDuration = () => duration < caption_min_time || duration > caption_max_time

  return (
    <>
      <CaptionETCArea> 
        <div className={`durationInfo ${isInvalidDuration() ? "active" : ""}`}>
          <em>
            {`${duration.toFixed(2)} (s)`} 
          </em>
        </div>
        <div className="lengthInfo">
          <span className={`length ${captionData.caption.length > text_limit ? "active" : ""}` }>{captionData.caption.length} </span>
          /
          <span className="limit"> {text_limit}</span>
        </div>
      </CaptionETCArea>
    </>
  );
}
const CaptionETCArea = styled.div`
  display: flex;
  flex-direction: column; 
  justify-content: space-between;
  text-align: center;
  margin:0 auto;
  
  .durationInfo {
    &.active{
        color:red;
      }
  }

  .lengthInfo{
    .length {
      &.active{
        color:red;
      }
    }
  }
  
`;
